import { AppSettings } from "@/AppSettings";
import { ConfigurationType } from "@/hooks/form/configuration";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { LoadingButton } from "@mui/lab";
import { Alert, Box, Chip, styled, useTheme } from "@mui/material";
import { useFormState } from "@ngt/forms-core";
import { FC, useMemo } from "react";
import FormSubmitButton from "../../FormSubmitButton";

const SpacingBox = styled(Box)(({ theme }) => {
    const top = parseInt(theme.spacing(7)) + 4

    return { 
        height: top,
        marginBottom: theme.spacing(-3)
    }
});

const Banner = styled(Box)(({ theme }) => {
    const top = parseInt(theme.spacing(7)) + 4

    return { 
        position: 'sticky',
        top: top,
        margin: theme.spacing(-3),
        background: theme.palette.common.white,
        zIndex: 100
    }
});

interface IConfigurationSourceDataFormBannerProps {
}

const ConfigurationSourceDataFormBanner: FC<IConfigurationSourceDataFormBannerProps> = ({
}) => {
    const { dirty } = useFormState({ dirty: true });

    const isDirty = useMemo(() => {
        let d = false;

        for (let c in dirty) {
            if (dirty[c]) {
                d = true;
                break;
            }
        }
        
        return d;
    }, [dirty])

    if (!isDirty) {
        return null; 
    }

    return (
        <>
            <Banner>
                <Alert
                    severity="warning"
                    action={
                        <FormSubmitButton
                            color="inherit"
                            size="small"
                            startIcon={
                                <FontAwesomeIcon icon={AppSettings.icons.save} />
                            }
                        >
                            Save
                        </FormSubmitButton>
                    }
                >
                    Changes have been made to this configuration.
                </Alert>
            </Banner>
            <SpacingBox />
        </>
    )
}

export default ConfigurationSourceDataFormBanner;